import React, { useState } from 'react';
import { TextField } from '@material-ui/core';

import {
  Container,
  Link,
  Button,
  ForgotPasswordForm,
} from '~/components/_layouts/forms/styles';
import { forgotPassword } from '~/api';

const validEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function PasswordRecovery() {
  const [email, updateEmail] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validEmailRegex.test(email)) {
      await forgotPassword(email);
    }
  };

  return (
    <Container>
      <ForgotPasswordForm>
        <div className="centered">
          <div className="recovery-title">Recupere sua senha</div>
          <div className="recovery-normal-text">
            Você receberá um e-mail de recuperação
          </div>
        </div>

        <form onSubmit={(event) => handleSubmit(event)}>
          <TextField
            fullWidth
            label="E-mail"
            value={email}
            variant="outlined"
            onChange={(event) => updateEmail(event.target.value)}
          />

          <Button fullWidth type="submit" variant="outlined">
            Recuperar senha
          </Button>
        </form>

        <Link to="/signin">Voltar para login</Link>
      </ForgotPasswordForm>
    </Container>
  );
}

export default PasswordRecovery;
